import { useEffect } from 'react'
import { useController, UseControllerProps, UseFormReturn } from 'react-hook-form'

import { InputFormValues } from '@/modules/CombinedLogs/types'
import { useWorkstationStore } from '@/modules/Workstation/store'
import { SuggestionInputTable } from '@/ui/SuggestionInputTable'
import styles from './TableFormRouteInput.module.scss'
import { useCombinedLogsTableFormStateStore } from '@/modules/CombinedLogs/store'
import { DailyLogCode } from '@/types/logs'
import { useGarageStore } from '@/modules/FindGarage'
import { useAuthStore } from '@/store/auth-store'
import { Role } from '@/types/auth'

interface Props extends Omit<UseControllerProps<InputFormValues>, 'name'> {
    name: keyof InputFormValues
    form: UseFormReturn<InputFormValues>
}

const NOT_APPLICABLE_OPTION = {
    id: 'N/A',
    label: 'N/A',
    value: 'N/A',
}

export const TableFormRouteInput = ({ form, ...props }: Props) => {
    const { field } = useController({ control: props.control, name: props.name })
    const { routes: workstationRoutes = [] } = useWorkstationStore()
    const { garage } = useGarageStore()
    const { role } = useAuthStore()
    const { setRoute, route } = useCombinedLogsTableFormStateStore()
    const code = form.watch('code')
    const formRoutes = form.watch('routes')
    const isInfoCode = code === DailyLogCode.Info

    const routes = role === Role.MileageClerk ? (garage?.routes ?? []) : workstationRoutes.map((route) => route.route)

    const handleChange = (value: string) => {
        field.onChange(value)
        setRoute(value)

        form.setValue('locationFrom', '')
        form.setValue('locationTo', '')
        form.setValue('direction', '')
    }

    const handleBlur = (value: string) => {
        field.onChange(value)
        setRoute(value)
    }

    const availableOptions = isInfoCode
        ? [
              ...routes.map((route) => ({
                  id: route,
                  label: route,
                  value: route,
              })),
              NOT_APPLICABLE_OPTION,
          ]
        : [
              ...routes.map((route) => ({
                  id: route,
                  label: route,
                  value: route,
              })),
          ]

    useEffect(() => {
        if (code && !isInfoCode && field.value === NOT_APPLICABLE_OPTION.value) {
            form.setValue('routes', '')
        }
    }, [code, isInfoCode, field.value])

    useEffect(() => {
        if (formRoutes && formRoutes.length == 1 && !route) {
            setRoute(formRoutes.at(0) as string)
        }
    }, [formRoutes, route])
    return (
        <SuggestionInputTable
            options={availableOptions}
            variant="table"
            type="text"
            transparent
            fullWidth
            className={styles.routeSuggestionMenu}
            inputClassName={styles.routeInput}
            placeholder="Route"
            value={field.value}
            onChange={handleChange}
            onBlurHandler={handleBlur}
            displayValueInsteadOfLabel
            onlyFromDropdown
        />
    )
}
